export const walletTypes = {
  GET_ALL_WALLETS: '[WALLET]-GET_ALL_WALLETS',
  CHARGE_BALANCE: '[WALLET]-CHARGE_BALANCE',
  GET_WALLET: '[WALLET]-GET_WALLET',
  CLEAN_WALLET: '[WALLET]-CLEAN',
};
